/***
 *
 *   CHIP STYLES
 *   Ported from ui-reference/src/components/tickets/ticket-attribute-chip.tsx.
 *
 *   The tint keys carry border + background + text together, so a chip is one
 *   token lookup. Priority and status maps live beside them because they are
 *   the only consumers and the reference keeps them adjacent too.
 *
 **********/

const Style = {
    base: 'inline-flex max-w-full items-center gap-1.5 rounded-md border px-2 py-0.5 text-xs font-medium leading-tight',
    dot: 'h-1.5 w-1.5 shrink-0 rounded-full',
    label: 'min-w-0 truncate',
};

export const PRIORITY_STYLES = {
    urgent: {
        tint: 'border-priority-urgent/35 bg-priority-urgent/10 text-priority-urgent dark:bg-priority-urgent/15',
        dot: 'bg-priority-urgent',
    },
    high: {
        tint: 'border-priority-high/35 bg-priority-high/10 text-priority-high dark:bg-priority-high/15',
        dot: 'bg-priority-high',
    },
    medium: {
        tint: 'border-priority-medium/35 bg-priority-medium/10 text-priority-medium dark:bg-priority-medium/15',
        dot: 'bg-priority-medium',
    },
    low: {
        tint: 'border-priority-low/35 bg-priority-low/10 text-priority-low dark:bg-priority-low/15',
        dot: 'bg-priority-low',
    },
};

export const STATUS_STYLES = {
    pending: {
        tint: 'border-status-pending/35 bg-status-pending/10 text-status-pending dark:bg-status-pending/15',
        dot: 'bg-status-pending',
    },
    in_progress: {
        tint: 'border-status-inProgress/35 bg-status-inProgress/10 text-status-inProgress dark:bg-status-inProgress/15',
        dot: 'bg-status-inProgress',
    },
    on_hold: {
        tint: 'border-status-onHold/35 bg-status-onHold/10 text-status-onHold dark:bg-status-onHold/15',
        dot: 'bg-status-onHold',
    },
    completed: {
        tint: 'border-status-completed/35 bg-status-completed/10 text-status-completed dark:bg-status-completed/15',
        dot: 'bg-status-completed',
    },
    closed: {
        tint: 'border-status-closed/40 bg-status-closed/10 text-status-closed dark:bg-status-closed/20',
        dot: 'bg-status-closed',
    },
};

export default Style;
